import type { SchedulerBooking } from '@/types/scheduler';
import { matchesFilters, type CalendarFilters } from './calendarFilters';

// NOT-318/320 — cancelled jobs for the calendar's Cancelled rail section. Scoped
// by the active calendar filters (assignee/event type/job type/skills) to match
// the grid, most recent first. The status filter is intentionally ignored here:
// the rail is intrinsically "cancelled", so a status checkbox must not empty it.
export function selectCancelledBookings(
  bookings: SchedulerBooking[],
  filters: CalendarFilters,
): SchedulerBooking[] {
  const filtersWithoutStatus: CalendarFilters = { ...filters, statuses: [] };
  // §15 — a cancelled day-bound visit has no startAt; sort it by its
  // scheduledDate day so it lands among that day's cancellations, not at the end.
  const sortKey = (b: SchedulerBooking) => b.startAt ?? b.scheduledDate ?? '';
  return bookings
    .filter((b) => b.status === 'CANCELLED' && matchesFilters(b, filtersWithoutStatus))
    .sort((a, b) => sortKey(b).localeCompare(sortKey(a)));
}
